import React from 'react';
import { FilterOutlined } from '@ant-design/icons';

/**
 * DashboardFilters
 * Top filter bar — Date Range, Project Owner, Project selectors.
 * Uses Ant Design icons only — no Material Symbols dependency.
 */
export default function DashboardFilters({ filters, onFilterChange, projects = [], employees = [] }) {
    const handleChange = (key, value) => onFilterChange({ ...filters, [key]: value });

    const selectClass = 'bg-white dark:bg-[#1e293b] border-none text-sm font-semibold text-[#191c1d] dark:text-white rounded-xl focus:ring-2 focus:ring-[#28b5fd] py-2.5 shadow-sm cursor-pointer outline-none';

    return (
        <div className="flex flex-wrap items-center gap-3 bg-[#f3f4f5] dark:bg-[#1e293b] p-2 rounded-2xl">

            {/* Date Range */}
            <div className="relative">
                <label className="absolute -top-2 left-3 bg-[#f8f9fa] dark:bg-[#0f172a] text-xs font-bold text-[#424750] dark:text-slate-400 px-1 rounded z-10 pointer-events-none">
                    Date Range
                </label>
                <select
                    value={filters.dateRange || 'All Time'}
                    onChange={(e) => handleChange('dateRange', e.target.value)}
                    className={`${selectClass} min-w-[140px] pl-3 pr-8`}
                >
                    <option>All Time</option>
                    <option>This Week</option>
                    <option>Today</option>
                    <option>Last 30 Days</option>
                </select>
            </div>

            {/* Project Owner */}
            <div className="relative">
                <label className="absolute -top-2 left-3 bg-[#f8f9fa] dark:bg-[#0f172a] text-xs font-bold text-[#424750] dark:text-slate-400 px-1 rounded z-10 pointer-events-none">
                    Project Owner
                </label>
                <select
                    value={filters.owner || ''}
                    onChange={(e) => handleChange('owner', e.target.value)}
                    className={`${selectClass} min-w-[150px] pl-3 pr-8`}
                >
                    <option value="">All Owners</option>
                    {employees.map((emp) => (
                        <option key={emp._id} value={emp._id}>
                            {emp.name} {emp.surname || ''}
                        </option>
                    ))}
                </select>
            </div>

            {/* Project */}
            <div className="relative">
                <label className="absolute -top-2 left-3 bg-[#f8f9fa] dark:bg-[#0f172a] text-xs font-bold text-[#424750] dark:text-slate-400 px-1 rounded z-10 pointer-events-none">
                    Project
                </label>
                <select
                    value={filters.projectId || ''}
                    onChange={(e) => handleChange('projectId', e.target.value)}
                    className={`${selectClass} min-w-[160px] pl-3 pr-8`}
                >
                    <option value="">All Projects</option>
                    {projects.map((p) => (
                        <option key={p._id} value={p._id}>{p.name}</option>
                    ))}
                </select>
            </div>

            {/* Work Item Type (Section 25) */}
            <div className="relative">
                <label className="absolute -top-2 left-3 bg-[#f8f9fa] dark:bg-[#0f172a] text-xs font-bold text-[#424750] dark:text-slate-400 px-1 rounded z-10 pointer-events-none">
                    Work Item Type
                </label>
                <select
                    value={filters.itemType || ''}
                    onChange={(e) => handleChange('itemType', e.target.value)}
                    className={`${selectClass} min-w-[140px] pl-3 pr-8`}
                >
                    <option value="">All Types</option>
                    <option value="task">Tasks</option>
                    <option value="milestone">Milestones</option>
                </select>
            </div>

            {/* Filter button */}
            <button className="bg-[#e7e8e9] dark:bg-[#334155] hover:bg-[#e1e3e4] dark:hover:bg-[#475569] p-2.5 rounded-xl transition-all">
                <FilterOutlined className="text-[#191c1d] dark:text-white" style={{ fontSize: 16 }} />
            </button>
        </div>
    );
}
